module.exports = __webpack_public_path__ + "img/3.4008d2e4.jpg";